import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getDeploymentTemplatesList } from "../../services/pdmApi.service";
import type { DeploymentTemplateOption } from "../../types/pdm.types";

const DEPLOYMENT_TEMPLATES_OPTIONS_LIMIT = 20;

export function useDeploymentTemplateOptions() {
  const query = useQuery({
    queryKey: ["deploymentTemplateOptions", 0, DEPLOYMENT_TEMPLATES_OPTIONS_LIMIT],
    queryFn: () =>
      getDeploymentTemplatesList({
        offset: 0,
        limit: DEPLOYMENT_TEMPLATES_OPTIONS_LIMIT,
      }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const options = useMemo<DeploymentTemplateOption[]>(
    () => (query.data?.items ?? []).map((t) => ({ id: t.id, name: t.name })),
    [query.data],
  );

  return {
    ...query,
    options,
  };
}

